<template>
<!-- 门店管理 -->
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="108px">
      <el-form-item label="门店名称:" prop="storeName">
        <el-input v-model="queryParams.storeName" placeholder="请输入门店名称" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="药企名称:" prop="enterpriseName">
        <el-input v-model="queryParams.enterpriseName" placeholder="请输入药企名称" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
         <el-button :disabled="!storeList.length" size="mini" type="primary" icon="el-icon-edit" @click="handleMemberTransfer">会员转移</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column width="50" type="selection" :fixed="true"></el-table-column>
      <el-table-column label="门店名称" align="center" prop="storeName" />
      <el-table-column label="联系方式" prop="contactPhone"></el-table-column>
      <el-table-column label="所属药企" prop="enterpriseName"></el-table-column>
      <el-table-column align="center" label="服务团队" prop="storeHealthManagerRelations">
        <el-table-column v-for="(item,index) in [{name:'专属医生',type: 1},{name:'健康管理师',type: 2},{name:'营养师',type: 3}]" :key="item.type" :label="item.name">
          <template slot-scope="{row}">
            <el-tag :type="['info','success', 'warning'][index]">{{findInfoByType(item.type, row.storeHealthManagerRelations)}}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="注册时间" align="center" prop="createTime" width="180" />

      <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
        </template>
      </el-table-column> -->
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
     <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form ref="form1" :inline="true" :rules="rules1"  :model="form1" class="demo-form-inline">
        <el-form-item label="专属医生:" prop="healthManagerId">
          <el-select element-loading-spinner="el-icon-loading"  v-loading="selctLoading" @change="handleChangePeople($event,1)" v-model="form1.healthManagerId" placeholder="请选择人员">
            <el-option v-for="item in healthPeople1" :key="item.doctorId" :label="item.doctorName" :value="item.doctorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit('form1',1)">提交</el-button>
        </el-form-item>
      </el-form>
      <el-form ref="form2" :inline="true" :rules="rules2"  :model="form2" class="demo-form-inline">
        <el-form-item label="健康管理师:" prop="healthManagerId">
          <el-select element-loading-spinner="el-icon-loading"  v-loading="selctLoading" @change="handleChangePeople($event, 2)" v-model="form2.healthManagerId" placeholder="请选择人员">
            <el-option v-for="item in healthPeople2" :key="item.doctorId" :label="item.doctorName" :value="item.doctorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit('form2',2)">提交</el-button>
        </el-form-item>
      </el-form>
      <el-form ref="form3" :inline="true" :rules="rules3"  :model="form3" class="demo-form-inline">
        <el-form-item label="营养师:" prop="healthManagerId">
          <el-select element-loading-spinner="el-icon-loading"  v-loading="selctLoading" @change="handleChangePeople($event, 3)" v-model="form3.healthManagerId" placeholder="请选择人员">
            <el-option v-for="item in healthPeople3" :key="item.doctorId" :label="item.doctorName" :value="item.doctorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit('form3',3)">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 会员转移 -->
    <el-dialog
      :title="title02"
      :visible.sync="open"
      width="70%"
      :before-close="handleClose02">
      <member-transfer :storeList="storeList" @success="success" :open="open"></member-transfer>
    </el-dialog>
  </div>
</template>

<script>
let self = null;
import { getRelationList, saveOrUpdateRelation, getDoctorList } from "@/api/system/doctorManage";
import {deepClone} from '@/utils/index'
import configurationForm from '../components/configurationForm.vue'
import memberTransfer from '../components/memberTransfer/index.vue'
export default {
  name: "storeManage",
  components: {  configurationForm, memberTransfer },
  data() {
    return {
      open: false,
      title02: '会员转移',
      title: '',
      form1: {
        healthManagerId: null,
        healthManagerName: null
      },
      form2: {
        healthManagerId: null,
        healthManagerName: null
      },
      form3: {
        healthManagerId: null,
        healthManagerName: null
      },
      type: null,
      selctLoading: false,
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 弹出层标题
      title: "",
      doctorId: null,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 20,
      },
      // 表单参数
      // formData: {},
      // 表单校验
      dataList: [],
      loading: false,
      storeName: '',
      dialogVisible: false,
      formData: {
        healthManagerId: null,
        healthManagerType: 1
      },
      healthPeople1: [],
      healthPeople2: [],
      healthPeople3: [],
      // healthPeople4: [],
      healthManagerId1: undefined,
      healthManagerId2: undefined,
      healthManagerId3: undefined,
      // healthManagerId4: undefined,
      newObj: {
        storeId: null,
        storeName: null,
        healthManagerName: null,
        healthManagerId: null
      },
      rules1: {
        healthManagerId: [{required: true, message: '请选择服务人员', trigger: 'change'}],
      },
      rules2: {
        healthManagerId: [{required: true, message: '请选择服务人员', trigger: 'change'}],
      },
      rules3: {
        healthManagerId: [{required: true, message: '请选择服务人员', trigger: 'change'}],
      },
      storeHealthManagerRelations: [],
      storeList: []
    };
  },
  created() {
    self = this;
    self.loading = false;
    self.getList();
  },
  mounted() {

  },
  methods: {
    /**table checkbox事件 */
    handleSelectionChange(val) {
      this.storeList = val
    },
    /**
     * 会员转移
     */
    success() {
      this.open = false
    },
    /**
     * 点击会员转移按钮
     */
    handleMemberTransfer() {
      this.open = true
    },
    // 根据不同的类型获取对应的医生列表
    handleGetListByType() {
      for (let i = 1; i < 4; i++) {
        this.getDoctorList(i).then(res => {
          this[`healthPeople${i}`] = res.data.records || [];
        })
      }
    },
    // 获取医护人员列表
    getDoctorList(type) {
      const data = {
        pageNum: 1,
        pageSize: 1000,
        healthManagerType: type
      }
      return new Promise((reslove, reject) => {
        getDoctorList(data).then(res => {
         reslove(res)
        })
      })
    },
    // 根据type找到数据
    findInfoByType(type,array) {
      const obj = array.find(item => {
        return item.healthManagerType === type
      })
      if(obj) {
        return obj.healthManagerName
      }else {
        // return '暂无医生'
        switch (type) {
          case 1:
            return '暂无专属医生'
            break;
          case 2:
            return '暂无健康管理师'
            break;
          case 3:
            return '暂无营养师'
            break;
          case 4:
            return '暂无药师'
            break;
          default:
            return ''
            break;
        }
      }
    },
    submit(formName,type) {
      // console.log({e});
      // this.formData.healthManagerId = undefined
      // let id = undefined
      // let name = undefined
      let id = this[`form${type}`].healthManagerId
      let  name = this[`form${type}`].healthManagerName
      const obj = this.storeHealthManagerRelations.find(item => {
        return item.healthManagerType === type
      })
      this.newObj.healthManagerType = type
      this.newObj.healthManagerId = id
      this.newObj.healthManagerName = name
      if(obj) {
        this.newObj.id = obj.id
        this.newObj.healthManagerId = this.newObj.healthManagerId?this.newObj.healthManagerId: obj.healthManagerId
        this.newObj.healthManagerName = this.newObj.healthManagerName?this.newObj.healthManagerName:obj.healthManagerName
      }else {
        this.newObj.id = null
        // this.formData.healthManagerId = this.id
      }
      // console.log('this.newObj', this.newObj);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = deepClone(this.newObj)
          // console.log({data});
          saveOrUpdateRelation(data).then(res => {
            this.$message.success('配置人员成功')
            this.getList()
            // this.dialogVisible = false
          })
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 下拉框change事件
    handleChangePeople(val, type) {
      this.type = type
      const obj = this[`healthPeople${type}`].find(item => {
        return item.doctorId === val
      })
      if(obj) {
        // this.newObj.healthManagerName = obj.doctorName
        this[`form${type}`].healthManagerName = obj.doctorName
      }
    },
    // change事件
    handleChange(val) {
      // console.log({val});
      this.selctLoading = true
      this.formData.healthManagerId = undefined
      const obj = this.storeHealthManagerRelations.find(item => {
        return item.healthManagerType === val
      })
      this.formData.healthManagerType = val
      if(obj) {
        this.formData.id = obj.id
        this.newObj.healthManagerId = obj.healthManagerId
        // this.formData.healthManagerId = obj.healthManagerId
      }else {
        this.formData.id = null
        this.formData.healthManagerId = null
      }
      this.getDoctorList(val)
    },
    /**
     * 会员转移弹框关闭前的钩子
     * @param {function} done 回调函数用来处理对话框
     */
    handleClose02(done) {
      done()
    },
    // 弹框关闭前钩子
    handleClose(done) {
      // this.dialogVisible = false
      done()
      setTimeout(_=>{
        this.form1 =  {
          healthManagerId: null
        }
        this.form2 = {
          healthManagerId: null
        }
        this.form3 =  {
          healthManagerId: null
        }
        // this.form4 =  {
        //   healthManagerId: null
        // }
      },500)
    },
    handleGetId(arr) {
      for (let i = 1; i < 4; i++) {
        const obj = arr.find(item => {
          return item.healthManagerType === i
        })
        if(obj) {
          this[`form${i}`].healthManagerId = obj.healthManagerId
        }
      }
    },
    // 配置门店
    handleConfiguration(row) {
      // this.Configurations = deepClone(row)
      const {id, storeName, storeHealthManagerRelations} = row
      this.newObj.storeId = id
      this.newObj.storeName = storeName
      this.title = `${storeName} - 配置人员`
      this.dialogVisible = true
      this.$nextTick(_=>{
        this.$refs.form1.clearValidate()
        this.$refs.form2.clearValidate()
        this.$refs.form3.clearValidate()
        // this.$refs.form4.clearValidate()
      })
      this.storeHealthManagerRelations = storeHealthManagerRelations
      // 获取对应的id并回显
      this.handleGetListByType()
      this.handleGetId(storeHealthManagerRelations)
    },
    getList() {
      getRelationList(self.queryParams).then((res) => {
        if (res.code == 200) {
          self.dataList = res.data.records || [];
          self.total = res.data.total || 0;
        }
      })
    },
    // 表单重置
    reset() {
      this.areaList = [];
      this.doctorId = null;
      this.form = {
        id: null,
        enterpriseName: null,
        enterpriseCity: null,
        detailAddress: null,
        enterpriseAccount: null,
        enterprisePassword: null,
        accountStatus: "1",
        chargePerson: null,
        contactWay: null,
        businessLicense: null,
        saleLicense: null,
        expiryStartDate: null,
        expiryEndDate: null,
        enterpriseRemark: null,
        isDelete: null,
        createPerson: null,
        createTime: null,
        updatePerson: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    handleDetail(rows) {
      this.$router.push({ path: '/healthManage_detail', query: { doctorId: rows.doctorId } });
    },
    handleClickItem() {
      // 获取遮罩层dom
      setTimeout(() => {
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      })
    },
  }
};
</script>
<style lang="less" scoped>
.demo-ruleForm {
  // width: 350px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.el-scrollbar__wrap .el-form {
  // margin-right: 15px !important;
}
.health_tag {
  margin: 30px;
  /deep/ .el-tag {
    margin-right: 20px;
    margin-bottom: 20px;
  }
}
</style>
